import { Minus, TrendingDown, TrendingUp } from 'lucide-react'
import type React from 'react'

interface ShiftChipProps {
    value: number
    previousValue?: number
    className?: string
}

export const ShiftChip: React.FC<ShiftChipProps> = ({ value, previousValue, className = '' }) => {
    // Trend Calculation
    const prevShift = previousValue ?? value
    const diff = value - prevShift
    const isUp = diff > 0
    const isDown = diff < 0
    const isUnchanged = diff === 0

    // Chip Styling
    const isPositive = value > 0

    // Exact StrikeChip Base Classes
    // relative w-24 h-8 flex items-center justify-center rounded-[10px] border text-[13px] font-bold tracking-tight shadow-sm transition-all mx-auto bg-white
    // Exact StrikeChip Base Classes
    // relative w-24 h-8 flex items-center justify-center rounded-[10px] border text-[13px] font-bold tracking-tight shadow-sm transition-all mx-auto bg-white
    const baseClasses =
        'relative w-24 h-8 flex items-center justify-center rounded-[10px] border text-[13px] font-bold tracking-tight shadow-sm transition-all mx-auto bg-white dark:bg-slate-800'

    // StrikeChip Color Logic (Support/Emerald vs Resistance/Rose)
    const colorClasses = isPositive
        ? 'bg-emerald-50 dark:bg-emerald-900/20 border-emerald-200 dark:border-emerald-800 text-emerald-700 dark:text-emerald-400'
        : 'bg-rose-50 dark:bg-rose-900/20 border-rose-200 dark:border-rose-800 text-rose-700 dark:text-rose-400'

    const neutralClasses = 'border-slate-100 dark:border-slate-700 text-slate-600 dark:text-slate-400'

    return (
        <div className={`flex flex-col items-center justify-center ${className}`}>
            <div className={`${baseClasses} ${value !== 0 ? colorClasses : neutralClasses}`}>
                <span className="mr-1">{value.toFixed(0)}</span>
                {isUp && <TrendingUp size={14} strokeWidth={2.5} />}
                {isDown && <TrendingDown size={14} strokeWidth={2.5} />}
                {isUnchanged && <Minus size={14} strokeWidth={2.5} className="opacity-50" />}
            </div>
        </div>
    )
}
